// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./TabTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tab-module__Tab__ELc8e {
    display: flex;
    flex-shrink: 0;
    gap: var(--ds-s);
    align-items: center;
    color: var(--ds-tab-color-default);
}

.Tab-module__Default__OoADM {
    padding: var(--ds-s) var(--ds-m);
    border-radius: var(--ds-border-radius-s);
}

.Tab-module__Ghost___DHlh {
    z-index: var(--ds-z-index-1);
    padding: var(--ds-m);
}

.Tab-module__Text__tPxXU {
    color: inherit;
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    line-height: var(--ds-line-height-small);
}

.Tab-module__Small__k7PZQ {
    padding: var(--ds-s);
}

.Tab-module__FullWidth__Vtqeg {
    flex: 1;
    justify-content: center;
}

.Tab-module__Tab__ELc8e:hover {
    cursor: pointer;
}
/* stylelint-disable-next-line selector-max-specificity -- spec */
.Tab-module__Tab__ELc8e:hover:not(.Tab-module__Active__qC2pZ) {
    color: var(--ds-tab-color-hover);
    background-color: var(--ds-interaction-hover);
}

.Tab-module__Tab__ELc8e:focus-visible {
    color: var(--ds-tab-color-focus);
    background: var(--ds-interaction-hover);
    outline: var(--ds-tab-focus-outline-color) solid
        var(--ds-border-width-focus);
}

.Tab-module__DefaultActive__VYanw {
    color: var(--ds-tab-color-active);
    background-color: var(--ds-interaction-select);
}

.Tab-module__GhostActive__OHLH9 {
    padding-bottom: var(--ds-sm);
    border-bottom: var(--ds-xs) solid var(--ds-tab-ghost-active-border-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Tab": `Tab-module__Tab__ELc8e`,
	"Default": `Tab-module__Default__OoADM`,
	"Ghost": `Tab-module__Ghost___DHlh`,
	"Text": `Tab-module__Text__tPxXU`,
	"Small": `Tab-module__Small__k7PZQ`,
	"FullWidth": `Tab-module__FullWidth__Vtqeg`,
	"Active": `Tab-module__Active__qC2pZ`,
	"DefaultActive": `Tab-module__DefaultActive__VYanw`,
	"GhostActive": `Tab-module__GhostActive__OHLH9`
};
export default ___CSS_LOADER_EXPORT___;
